import api from '@/api'

const { $commission, $core } = api;

export const { $payings } = $commission;
export const { $settings, $applications,$expirationDate } = $core;
